export { getErrorMessage, isRateLimited } from '@repo/utils'

export const fetchWithThrow = async (
  input: RequestInfo | URL,
  init?: RequestInit,
): Promise<Response> => {
  const res = await fetch(input, { ...init, credentials: 'include' })
  if (!res.ok) {
    const contentType = res.headers.get('Content-Type')

    if (contentType && contentType.includes('application/json')) {
      const json = await res.json()
      throw json
    }

    throw res
  }

  return res
}
